import { render, staticRenderFns } from "./CensusUploadStatus.vue?vue&type=template&id=4fce561c"
import script from "./CensusUploadStatus.vue?vue&type=script&lang=ts"
export * from "./CensusUploadStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports